export const initialState = {
  contributor: { cuit: "", name: "", address: "" },
  taxPayer: { name: "", cuit: "", mail: "" },
  duplicateData: false,
};
